module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-carousel', {
    staticClass: "main-projects__carousel",
    attrs: {
      "interval": 4000,
      "type": "card",
      "height": "500px"
    }
  }, _vm._l((_vm.availableProjects), function(project) {
    return _c('el-carousel-item', {
      key: project.id
    }, [_c('h3', {
      staticClass: "main-projects-label__h3"
    }, [_vm._v("\n      " + _vm._s(project.label) + "\n    ")]), _vm._v(" "), _c('iframe', {
      staticClass: "main-projects-preview__iframe",
      attrs: {
        "src": '/#/projects/' + project.id
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f37867b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/projects/projects.vue
// module id = 285
// module chunks = 0